<div class="cm-multiselect">
	<div class="cm-multiselect__search-container" *ngIf="searchable">
		<cm-search [formControl]="search"></cm-search>
		<button mat-button cm-mini-button type="button" *ngIf="!viewOnly" (click)="onSelectAll()">
			<span [cmLocalize]="this.localizationPrefix + '.Button.SelectAll'">
				Select All
			</span>
		</button>
		<button mat-button cm-mini-button type="button" *ngIf="!viewOnly" (click)="onUnselectAll()">
			<span [cmLocalize]="this.localizationPrefix + '.Button.UnselectAll'">
				Unselect All
			</span>
		</button>
	</div>
	<div class="cm-multiselect__option-container" *ngIf="filteredOptions.length; else noResults">
		<ng-container *ngIf="!viewOnly; else viewTpl">
			<span class="cm-multiselect__option" *ngFor="let opt of filteredOptions">
				<mat-checkbox [checked]="opt.selected" (change)="onSelect(opt.value)" [disabled]="this.disabled">{{
					opt.display }}</mat-checkbox>
			</span>
		</ng-container>
		<ng-template #viewTpl>
			<ng-container *ngFor="let opt of filteredOptions">
				<span class="cm-multiselect__option" *ngIf="opt.selected">
					{{ opt.display }}
				</span>
			</ng-container>
		</ng-template>
	</div>

	<ng-template #noResults>
		<div class="cm-multiselect__empty" *ngIf="initialized">
			<span [cmLocalize]="this.localizationPrefix + '.Content.NoResults'">
				No items to display
			</span>
		</div>
	</ng-template>
</div>
